import { useMemo, useRef, useState } from 'react';
import { Play, Sparkles, ChevronDown, Music } from 'lucide-react';
import '@/VideoWall.css';

const VIDEOS = [
  { id: 'eWQIuraGEdI', title: 'ART5 Kunstnachrichten', subtitle: 'Täglich um 19:25 auf oe24.TV – komplett KI-generiertes Studio & Figuren', cat: 'ki', onTv: true, mix: 'ki' },
  { id: 'Lgh9ii6ITc4', title: 'Indian Living – TV Spot', subtitle: 'Indisches Möbelhaus – Mischung aus Real-Dreh & KI', cat: 'ki', onTv: true, mix: 'mixed' },
  { id: 't4qqYTqscDk', title: 'Alexander Lindenhofer – Vernissage', subtitle: 'Vernissage-Video – Mischung aus KI & Real', cat: 'event', mix: 'mixed' },
  { id: 'jJIPN66I4KM', title: 'Entdecke die Magie der Erinnerungen', subtitle: 'KI-Spot für Indian Living Wiener Neustadt', cat: 'ki', onTv: true },
  { id: '7wwJitsvx1E', title: 'Wenn Holz Geschichten erzählt', subtitle: 'KI-Video für WINSTAGE - Home of Art', cat: 'ki', onTv: true },
  { id: 'Hf6T4TMimTA', title: 'Blacklight-Kunst: LaManda Luminecent', subtitle: 'KI-Video für WINSTAGE - Home of Art', cat: 'ki', onTv: true },
  { id: 'h3kIhVnckhQ', title: 'Meister Ambrosius #3: Der moderne Brennofen', subtitle: 'KI-Serie für La Pelote - Keramik bemalen', cat: 'ki' },
  { id: 'JFWxjWPxLdQ', title: 'Schüler? Lehrer? Kreativ? -10% bei La Pelote', subtitle: 'KI-Spot für La Pelote Künstlerbedarf', cat: 'ki', onTv: true },
  { id: 'dbYd3fzKu7A', title: 'Kunst, die wirklich etwas bedeutet', subtitle: 'KI-Video für WINSTAGE Wiener Neustadt', cat: 'ki' },
  { id: 'KP_zxH4M3wQ', title: 'Von grau zu bunt', subtitle: 'KI-Video: Wie echte Kunst dein Leben verändert – WINSTAGE', cat: 'ki' },
  { id: 'tUP7qHRqOt0', title: 'Farbe kennt keine Grenzen', subtitle: 'KI-Video über abstrakte Kunst bei WINSTAGE', cat: 'ki' },
  { id: 'io5WLDhJRPI', title: 'Winpark West - Verwirkliche deinen Traum!', subtitle: 'KI-generierter Werbespot für WinPark West', cat: 'ki', duration: '0:51' },
  { id: 'Q7h8_rCrVz8', title: 'Microspaces in der Winstage', subtitle: 'KI-Video für WINSTAGE Microspaces', cat: 'ki' },
  { id: 'KPT7jQZSi9c', title: 'Atra Vellion - Songcontest', subtitle: 'KI-Video für WINSTAGE – Supporting the Arts', cat: 'ki' },
  { id: 'orvlnanAlTc', title: 'Besuche WINSTAGE in Wiener Neustadt!', subtitle: 'KI-generierter Werbespot für WINSTAGE Home of Art', cat: 'ki', duration: '0:30' },
  { id: 'Mj7qp557RwI', title: 'Kennt ihr schon Indian Living?', subtitle: 'KI-Video für Indian Living Wiener Neustadt', cat: 'ki', duration: '0:15' },
  { id: 'FtEF5EWEIb4', title: 'La Pelote -10% für Künstler', subtitle: 'AI-generierter Promo-Clip für La Pelote Künstlerbedarf', cat: 'ki', duration: '0:26' },
  { id: 'FIeugms91mo', title: 'Osterhasen Suche bei Indian Living', subtitle: 'KI-Video für Oster-Aktion - Bis zu -50% Rabatt', cat: 'ki', duration: '0:15' },
  { id: 'KJTAsuDX-U4', title: 'Wien TANZT!', subtitle: 'W24 & Wirtschaftskammer Wien', cat: 'tv', duration: '56:34' },
  { id: 'w6SaEKInASo', title: 'Uschi - Obertauern', subtitle: 'Obertauern im Sommer', cat: 'tv', duration: '26:01' },
  { id: 'CP6Ni0trmFo', title: 'Uschi - Retzer Weintage', subtitle: 'Menschen in der Weinregion Retz', cat: 'tv', duration: '26:20' },
  { id: 'o72juPcZYHo', title: 'Tod und Vorurteil', subtitle: '40 Jahre HIV-Aktivismus in Österreich', cat: 'doku', duration: '27:43' },
  { id: 'qsrm_xOSfXA', title: 'Ledervisionen', subtitle: 'Lothar Lehner - Meister seines Handwerks', cat: 'interview' },
  { id: 'A--8rQOuJVI', title: 'Vienna Eagles', subtitle: 'LGBTQIA+ Rugby Team Wien', cat: 'interview' },
  { id: 'ItJAk40mpXU', title: 'Austro Galo', subtitle: 'Portugiesische Tapas & Weinbar', cat: 'interview' },
  { id: 'Os8TbWmugV0', title: 'Festival der Spätantike', subtitle: 'Carnuntum 333 - Zeitreise', cat: 'event', duration: '1:51' },
];

const CATEGORIES = [
  { key: 'alle', label: 'Alle' },
  { key: 'ki', label: 'KI-Videos' },
  { key: 'tv', label: 'TV' },
  { key: 'doku', label: 'Dokus' },
  { key: 'interview', label: 'Interviews' },
  { key: 'event', label: 'Events' },
];

const CAT_CHIP = { ki: 'KI', tv: 'TV', doku: 'DOKU', interview: 'INTERVIEW', event: 'EVENT' };

const MIX_LABEL = { ki: '100 % KI', mixed: 'KI + Real', real: 'Real gedreht' };

const INITIAL_COUNT = 6; // 2 Reihen à 3 Karten am Desktop

const FEATURED = VIDEOS.find((v) => v.id === '7wwJitsvx1E');

function VideoCard({ video, onPlay }) {
  const [frame, setFrame] = useState(0);
  const timer = useRef(null);
  const preloaded = useRef(false);
  const mixKey = video.mix || (video.cat === 'ki' ? 'ki' : 'real');

  const startPreview = () => {
    if (!preloaded.current) {
      [1, 2, 3].forEach((n) => {
        const img = new Image();
        img.src = `https://img.youtube.com/vi/${video.id}/hq${n}.jpg`;
      });
      preloaded.current = true;
    }
    let i = 0;
    timer.current = setInterval(() => {
      i = (i % 3) + 1;
      setFrame(i);
    }, 700);
  };

  const stopPreview = () => {
    clearInterval(timer.current);
    setFrame(0);
  };

  const thumb = frame === 0
    ? `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`
    : `https://img.youtube.com/vi/${video.id}/hq${frame}.jpg`;

  return (
    <div
      className="vw-card"
      data-testid={`vw-card-${video.id}`}
      onMouseEnter={startPreview}
      onMouseLeave={stopPreview}
      onClick={() => onPlay({ url: `https://www.youtube-nocookie.com/embed/${video.id}`, title: video.title })}
    >
      <div className="vw-thumb" style={{ backgroundImage: `url(${thumb})` }}>
        <span className={`vw-chip vw-chip-${video.cat}`}>{CAT_CHIP[video.cat]}</span>
        {video.onTv && <span className="vw-ontv" data-testid={`ontv-badge-${video.id}`}>on TV</span>}
        {video.duration && <span className="vw-duration">{video.duration}</span>}
        <span className={`vw-mix vw-mix-${mixKey}`} data-testid={`mix-badge-${video.id}`}>{MIX_LABEL[mixKey]}</span>
        <div className="vw-play-overlay"><Play size={42} /></div>
      </div>
      <div className="vw-info">
        <h4>{video.title}</h4>
        <p>{video.subtitle}</p>
      </div>
    </div>
  );
}

export default function VideoWall({ onPlay }) {
  const [active, setActive] = useState('alle');
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);
  const filtered = active === 'alle' ? VIDEOS : VIDEOS.filter((v) => v.cat === active);
  const shown = filtered.slice(0, visibleCount);
  const remaining = filtered.length - shown.length;
  const counts = useMemo(() => {
    const c = { alle: VIDEOS.length };
    VIDEOS.forEach((v) => { c[v.cat] = (c[v.cat] || 0) + 1; });
    return c;
  }, []);

  const playFeatured = () => onPlay({ url: `https://www.youtube-nocookie.com/embed/${FEATURED.id}`, title: FEATURED.title });
  const playMusic = () => onPlay({ url: 'https://www.youtube-nocookie.com/embed/G7LjvT17pyc', title: 'Notfallsong (Beate Glatz)' });

  return (
    <section className="videos-section" data-testid="videos-section">
      <div className="container">
        <h2 className="section-title" data-testid="videos-title" data-reveal>
          <span className="ai-badge">AI</span> Videoproduktion Wien
        </h2>
        <p className="section-subtitle" data-reveal>KI-Videos, TV-Produktionen, Dokus & Interviews – klick dich rein</p>

        {/* Featured Video */}
        <div className="vw-featured" data-reveal data-testid="featured-video" onClick={playFeatured}>
          <div
            className="vw-featured-bg"
            style={{ backgroundImage: `url(https://img.youtube.com/vi/${FEATURED.id}/maxresdefault.jpg)` }}
          ></div>
          <div className="vw-featured-overlay">
            <span className="vw-featured-tag"><Sparkles size={14} /> Featured KI-Video</span>
            <h3 className="vw-featured-question">
              Was würdest du mit KI generieren, um deine echten Leistungen &amp; Produkte hervorzuheben?
            </h3>
            <p className="vw-featured-meta">{FEATURED.title} – {FEATURED.subtitle}</p>
            <button
              className="vw-featured-play"
              data-magnetic="true"
              data-testid="featured-play-button"
              onClick={(e) => { e.stopPropagation(); playFeatured(); }}
            >
              <Play size={18} /> Jetzt ansehen
            </button>
          </div>
        </div>

        {/* Category Filter Tabs */}
        <div className="vw-tabs" data-reveal data-testid="video-filter-tabs">
          {CATEGORIES.map((c) => (
            <button
              key={c.key}
              className={`vw-tab ${active === c.key ? 'vw-tab-active' : ''}`}
              onClick={() => { setActive(c.key); setVisibleCount(INITIAL_COUNT); }}
              data-testid={`vw-tab-${c.key}`}
            >
              {c.label} <span className="vw-count">{counts[c.key] || 0}</span>
            </button>
          ))}
        </div>

        {/* Video Grid */}
        <div className="vw-grid revealed" data-reveal="stagger" data-testid="video-wall-grid" key={active}>
          {shown.map((v) => (
            <VideoCard key={v.id} video={v} onPlay={onPlay} />
          ))}
        </div>

        {remaining > 0 && (
          <div className="vw-load-more-wrap">
            <button
              className="vw-load-more"
              data-magnetic="true"
              data-testid="load-more-videos"
              onClick={() => setVisibleCount((c) => c + INITIAL_COUNT)}
            >
              <ChevronDown size={18} /> Mehr Videos anzeigen ({remaining})
            </button>
          </div>
        )}

        {/* Musikvideo Showcase */}
        <div className="vw-featured vw-music" data-reveal data-testid="music-video-banner" onClick={playMusic}>
          <div
            className="vw-featured-bg"
            style={{ backgroundImage: 'url(https://img.youtube.com/vi/G7LjvT17pyc/maxresdefault.jpg)' }}
          ></div>
          <div className="vw-featured-overlay">
            <span className="vw-featured-tag vw-music-tag"><Music size={14} /> Neu im Portfolio</span>
            <h3 className="vw-featured-question">Musikvideo? Alles klar!</h3>
            <p className="vw-featured-meta">Notfallsong – Beate Glatz | Offizielles Musikvideo</p>
            <button
              className="vw-featured-play vw-music-play"
              data-magnetic="true"
              data-testid="music-play-button"
              onClick={(e) => { e.stopPropagation(); playMusic(); }}
            >
              <Play size={18} /> Jetzt ansehen
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
